'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconArrowLeft = function IconArrowLeft(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'M3.03577532,12.1044134 C3.06549272,12.2100933 3.11372808,12.3115539 3.1804814,12.4035368 L8.19869193,19.300379 C8.38342877,19.5561685 8.67237614,19.6888 8.96700771,19.6888 C9.1593235,19.6888 9.35542877,19.6319579 9.52216561,19.5088 C9.94563929,19.2056421 10.0403761,18.6088 9.73058666,18.1824842 L5.80734711,12.7919579 L19.2232182,12.7919579 C19.747113,12.7919579 20.1705866,12.3656421 20.1705866,11.8445895 C20.1705866,11.3235368 19.747113,10.8972211 19.2232182,10.8972211 L5.8073471,10.8972211 L9.73058666,5.50669473 C10.0403761,5.08037894 9.94563929,4.49301052 9.52216561,4.18037895 C9.09774456,3.87722105 8.50563929,3.96248421 8.19869193,4.3888 L3.1804814,11.2856421 C3.11372808,11.377625 3.06549272,11.4790856 3.03577532,11.5847655 C3.03426677,11.5900469 3.03280301,11.5953467 3.0313845,11.6006646 C2.98952823,11.7603043 2.98952823,11.9288747 3.03144617,12.0884907 C3.03280301,12.0938323 3.03426677,12.0991321 3.03577532,12.1044134 Z', fill: color }),
    ' '
  );
};

IconArrowLeft.propTypes = {
  color: _propTypes2.default.string
};

IconArrowLeft.defaultProps = {
  color: _colors2.default.icons
};

IconArrowLeft.displayName = 'IconArrowLeft';

exports.default = IconArrowLeft;
module.exports = exports.default;